import { mapState } from 'vuex';
import get from 'lodash/get';
import { isNullOrEmpty } from '../../../../../utils/vuex';
import CoreDtwinStateBridgeMqtt from '@/components/core/dtwin/state/bridge/mqtt';
import CoreDtwinStateBridgeNiota from '@/components/core/dtwin/state/bridge/niota';
import CoreDtwinStateBridgeOpenweather from '@/components/core/dtwin/state/bridge/openweather';
import CoreDtwinStateBridgeWebsocket from '@/components/core/dtwin/state/bridge/websocket';
import CoreDtwinStateBridgeIncomingwebhook from '@/components/core/dtwin/state/bridge/incomingwebhook';
import ApiService from '@/services/apiService';
import iconsMixin from '@/components/core/dtwin/state/bridge/iconsMixin';
export default {
  name: 'CoreDtwinStateBridgeEdit',
  components: {
    CoreDtwinStateBridgeMqtt,
    CoreDtwinStateBridgeNiota,
    CoreDtwinStateBridgeOpenweather,
    CoreDtwinStateBridgeWebsocket,
    CoreDtwinStateBridgeIncomingwebhook
  },
  mixins: [iconsMixin],
  props: {
    // the current edited binding
    lclModel: {
      type: Object,
      required: false,
      default: () => ({})
    },
    // is this an 'edit', 'create'?
    mode: {
      type: String,
      required: false,
      default: () => 'edit'
    },
    bridgeConfigs: {
      type: Array,
      required: false,
      default: () => []
    },
    templateContext: {
      type: Boolean,
      required: false,
      default: false
    },
    vdTenantId: {
      type: Number,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      selectedBridgeConfig: null,
      loading: false,
      localBridgeConfigs: [...this.bridgeConfigs],
      showRetryButton: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions']),
    ...mapState('authentication', ['tenantId']),
    hasManageAllPermissions() {
      return this.permissions['all.manage'];
    },
    baseBridgeType() {
      return (get(this.selectedBridgeConfig, 'type') || '').replace(/^bridge-/, '');
    },
    bridgeComponentExists() {
      if (!this.baseBridgeType) {
        return false;
      }
      return this.$options.components[`CoreDtwinStateBridge${this.baseBridgeType[0].toUpperCase()}${this.baseBridgeType.slice(1)}`];
    },
    formIsValid() {
      return (
        // if a bridge has no UI, mark it as valid in any case
        !this.bridgeComponentExists || !isNullOrEmpty(this.selectedBridgeConfig) && this.$refs[`${this.baseBridgeType}-bridge-config`] && this.$refs[`${this.baseBridgeType}-bridge-config`].formIsValid
      );
    }
  },
  watch: {
    selectedBridgeConfig(val) {
      if (this.lclModel && val && val.configId) {
        this.lclModel.properties.binding.options.configId = val.configId;
        this.lclModel.properties.binding.options.virtualDevice = undefined;
      }
      if (!this.loading) {
        this.$nextTick(() => {
          if (!isNullOrEmpty(this.$refs.bridgeConfigs)) {
            const dsInput = this.$refs.bridgeConfig.$el.querySelector('input');
            dsInput.blur();
          }
        });
      }
    }
  },
  created() {
    if (this.mode === 'create' || this.mode === 'import') {
      if (this.bridgeConfigs && this.bridgeConfigs.length === 1) {
        this.selectedBridgeConfig = this.bridgeConfigs[0];
      }
    } else {
      this.loading = true; // prevent the auto-complete field to be unnecessarily focused (see watcher `selectedBridgeConfig`)
      this.selectedBridgeConfig = this.bridgeConfigs.find(ds => ds.configId === parseInt(this.lclModel.properties.binding.options.configId));
    }
    if (!this.bridgeConfigs || !this.bridgeConfigs.length) {
      this.showRetryButton = true;
    }
  },
  methods: {
    openBridgeConfig() {
      this.$router.push({
        path: `/connectors/edit/${this.selectedBridgeConfig.tenantId}/${this.selectedBridgeConfig.configId}`
      });
    },
    bridgeBindingChanged(val) {
      this.$emit('bridge-binding-changed', val);
      this.loading = false;
    },
    saveState() {
      this.lclModel.properties.binding.options.configId = get(this.selectedBridgeConfig, 'configId');
      if (this.formIsValid && this.bridgeComponentExists) {
        this.$refs[`${this.baseBridgeType}-bridge-config`].saveState();
      }
    },
    bridgeConfig(bridge, types) {
      const foundMatch = types.find(config => {
        return config.type === bridge.type;
      });
      return foundMatch;
    },
    loadBridgeConfigs() {
      return Promise.all([ApiService.getBridgeTypes(), ApiService.getBridgesForTenant(this.vdTenantId)]);
    },
    async retryFetchBridges() {
      this.loadBridgeConfigs().then(configData => {
        this.showRetryButton = false;
        const types = configData[0];
        const configs = configData[1];
        this.localBridgeConfigs = configs.filter(config => get(this.bridgeConfig(config, types), 'manifest.functionScope.invokeDirection.inbound')).map(config => {
          return {
            type: config.type,
            image: this.bridgeTypesIcons[config.type],
            title: config.name,
            configId: config.id,
            tenantId: config.tenantId
          };
        });
        this.selectedBridgeConfig = this.localBridgeConfigs.find(ds => ds.configId === parseInt(this.lclModel.properties.binding.options.configId));
      }).catch(error => {
        this.showRetryButton = true;
        this.$snack(this.$i18n_t('Connectors.Connectors.errors.errorWhileFetchingConnectos'), 'error');
        console.error('Error', error);
      });
    }
  }
};